import greeceContactsConfig from "./contacts.config";

// Greece has a single office currently; extendable for future branches
const officesConfig = [greeceContactsConfig];

export default officesConfig;
